
import { Vue, Component, Prop } from 'nuxt-property-decorator'

@Component({
  name: 'Album',
})
export default class Album extends Vue {
  @Prop({ required: true }) readonly images: any
  @Prop({ required: false, default: 1 }) showCount: Number

  beforeMount() {
    let showCount = this.showCount
    if (this.showCount > this.images.length) {
      showCount = this.images.length
    }
    this.optionGalleries.slidesPerView = showCount
  }

  optionGalleries: any = {
    spaceBetween: 15,

    slidesPerGroup: 1,
    slidesPerView: 3,

    loop: true,
    loopFillGroupWithBlank: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      clickable: true,
    },
  }
}
